import { render } from "./BaseCarousel.vue?vue&type=template&id=658a10c7&scoped=true"
import script from "./BaseCarousel.vue?vue&type=script&lang=js"
export * from "./BaseCarousel.vue?vue&type=script&lang=js"

import "./BaseCarousel.vue?vue&type=style&index=0&id=658a10c7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658a10c7"]])

export default __exports__